import type { Urls } from '@b-stock/listing-api-client'

import { getLegacyBpStaticPath } from '@/buyer-portal/buyUrlPrefix'

import type { ParsedVideo } from './videoLinkParser'

export function getThumbnailUrls(video: ParsedVideo): Urls {
  if (video.platform === 'youtube') {
    return {
      large: `https://img.youtube.com/vi/${video.videoId}/maxresdefault.jpg`,
      original: `https://img.youtube.com/vi/${video.videoId}/maxresdefault.jpg`,
      medium: `https://img.youtube.com/vi/${video.videoId}/sddefault.jpg`,
      thumb: `https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg`,
    }
  }

  // Vimeo: placeholder (real thumbnail fetched asynchronously)
  const placeholder = getLegacyBpStaticPath('images/placeholder-image.png')
  return {
    large: placeholder,
    thumb: placeholder,
    medium: placeholder,
    original: placeholder,
  }
}

interface VimeoOEmbedResponse {
  thumbnail_url?: string
}

export async function fetchVimeoThumbnail(
  videoId: string
): Promise<string | null> {
  // Check localStorage cache first
  const cached = localStorage.getItem(`vimeo-thumbnail-${videoId}`)
  if (cached) return cached

  try {
    const response = await fetch(
      `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`
    )
    if (!response.ok) return null

    const data = (await response.json()) as VimeoOEmbedResponse
    const url = data.thumbnail_url

    if (!url) return null

    // Cache the thumbnail url
    localStorage.setItem(`vimeo-thumbnail-${videoId}`, url)
    return url
  } catch {
    return null
  }
}
